// src/icons/DotGrid1x3Horizontal.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function DotGrid1x3Horizontal() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("g", { id: "dot-grid-1x3-horizontal, menu, drag, grab", children: /* @__PURE__ */ jsxs("g", { id: "Icon", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.00001 6.66663H1.33334V9.33329H4.00001V6.66663Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9.33334 6.66663H6.66668V9.33329H9.33334V6.66663Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M14.6667 6.66663H12V9.33329H14.6667V6.66663Z",
            fill: "currentColor"
          }
        )
      ] }) })
    }
  );
}

export {
  DotGrid1x3Horizontal
};
